import React from 'react';
import { clsx } from 'clsx';

interface BadgeProps {
  label: string;
  variant?: 'info' | 'success' | 'warning' | 'danger' | 'neutral';
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ label, variant = 'neutral', className }) => {
  const styles = {
    info: 'bg-sky-500/10 text-sky-400 border-sky-500/20',
    success: 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20',
    warning: 'bg-amber-500/10 text-amber-400 border-amber-500/20',
    danger: 'bg-rose-500/10 text-rose-400 border-rose-500/20',
    neutral: 'bg-slate-700/50 text-slate-300 border-slate-600/50',
  };

  return (
    <span className={clsx('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border', styles[variant], className)}>
      {label}
    </span>
  );
};

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const normalized = status.toUpperCase();
  let variant: BadgeProps['variant'] = 'neutral';

  if (['NEW', 'SUBMITTED'].includes(normalized)) variant = 'info';
  if (['IN_PROGRESS', 'ASSIGNED', 'UNDER_INSPECTION'].includes(normalized)) variant = 'warning';
  if (['COMPLETED', 'VERIFIED', 'CLOSED', 'INSPECTION_PASSED'].includes(normalized)) variant = 'success';
  if (['CANCELLED', 'REJECTED', 'OVERDUE', 'INSPECTION_FAILED'].includes(normalized)) variant = 'danger';
  if (['PENDING_VERIFICATION'].includes(normalized)) variant = 'info';

  return <Badge label={status} variant={variant} />;
};

export const PriorityBadge: React.FC<{ priority: string }> = ({ priority }) => {
  const normalized = priority.toUpperCase();
  let variant: BadgeProps['variant'] = 'neutral';

  if (normalized === 'LOW') variant = 'info';
  if (normalized === 'MEDIUM') variant = 'warning';
  if (['HIGH', 'CRITICAL'].includes(normalized)) variant = 'danger';

  return <Badge label={priority} variant={variant} />;
};
